<script>
import Base from './base';

export default {
  extends: Base,
  data() {
    return {
      showCycleAlert: true,
    }
  },
};
</script>
